module.exports = __webpack_public_path__ + "static/media/han.ce7787d8.png";